'use client';

import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import styles from './Fireworks.module.scss';

const ReactFireworks = dynamic(() => import('@fireworks-js/react').then((mod) => mod.Fireworks), {
  ssr: false,
});

const MOBILE_BREAKPOINT = 768;
const INTENSITY_MOBILE = 10;
const INTENSITY_DESKTOP = 15;
const PARTICLES_MOBILE = 20;
const PARTICLES_DESKTOP = 50;

export const Fireworks = () => {
  const [intensity, setIntensity] = useState(INTENSITY_MOBILE);
  const [particles, setParticles] = useState(PARTICLES_MOBILE);

  useEffect(() => {
    const updateSettings = () => {
      const isMobile = window.innerWidth < MOBILE_BREAKPOINT;
      setIntensity(isMobile ? INTENSITY_MOBILE : INTENSITY_DESKTOP);
      setParticles(isMobile ? PARTICLES_MOBILE : PARTICLES_DESKTOP);
    };

    updateSettings();
    window.addEventListener('resize', updateSettings);
    return () => window.removeEventListener('resize', updateSettings);
  }, []);

  return (
    <div className={styles.fireworks} aria-hidden="true">
      <ReactFireworks
        options={{
          hue: { min: 185, max: 185 },
          acceleration: 1.02,
          brightness: { min: 100, max: 100 },
          decay: { min: 0.011, max: 0.011 },
          delay: { min: 30, max: 60 },
          explosion: 2,
          flickering: 0,
          intensity,
          friction: 0.97,
          gravity: 1.5,
          opacity: 0.3,
          particles,
          traceLength: 4,
          traceSpeed: 1,
          rocketsPoint: { min: 40, max: 60 },
          lineWidth: {
            explosion: { min: 1, max: 2 },
            trace: { min: 0.1, max: 1 },
          },
          lineStyle: 'round',
        }}
        style={{
          width: '100%',
          height: '100%',
        }}
      />
    </div>
  );
};
